
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/mobile-optimizations.css' // Mobile-first optimizations
import './i18n' // Initialize i18n
import { displayProductionStatus } from './utils/productionCheck'
import { registerServiceWorker, setupAssetRecovery } from './utils/productionOptimizations'
import './utils/productionLogger' // Initialize production logging
import './utils/consoleNoiseFilter' // Silence noisy external postMessage errors

// Production readiness check
displayProductionStatus();

// Service worker cleanup and asset recovery safety net
registerServiceWorker();
setupAssetRecovery();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
